
module.directive('newStudentForm', function($q) {
    return {
        restrict: 'E',
        templateUrl: 'students/newStudentForm',
        controllerAs: "ctrl",
        scope: {
            programId: '=',
            studentCreated: '&',
        },
        controller: function($scope, $state, Notifications, ModelService) {
            var ctrl = this;

            this.studentName = "";
            this.enrollDate = null;
            this.similar = [];

            this.createStudent = function(goToStudent) {
                if ($scope.form.$valid) {
                    return ModelService.post('participant', {
                        program_id: $scope.programId,
                        name: ctrl.studentName,
                        start_date: ctrl.enrollDate,
                    }).then(function(student) {
                        ctrl.studentName = "";
                        ctrl.similar = [];

                        if (goToStudent) {
                            $state.go('student.demographics', {id: student.id});
                        }

                        $scope.form.$setSubmitted(false);
                        $scope.studentCreated({student: student});
                    });
                } else {
                    Notifications.error('Please enter all required fields');
                    return $q.reject();
                }
            };

        },
    };
});
